import { type FC } from "react"

import { usePlatform } from "~/contexts/PlatformContext"
import Layout from "~/themes/original/components/Layout"
import PartialLoadingPage from "~/themes/original/components/PartialLoadingPage"
import { query } from "~/utilities/trpc"

import ActiveCourses from "./ActiveCourses"
import Calendar from "./Calendar"
import Gamification from "./Gamification"

const DashboardPage: FC = () => {
	const platform = usePlatform().platform

	if (platform.brandId === "goran") return <GoranDashboard />

	return (
		<Layout>
			<div className="grid grid-cols-1 gap-8 md:grid-cols-[minmax(0,400px)_minmax(0,400px)]">
				{platform.content.courses && <ActiveCourses className="row-span-2" />}
				{platform.content.events && <Calendar />}
				<Gamification />
			</div>
		</Layout>
	)
}

const GoranDashboard: FC = () => {
	const { data, error } = query.platform.getStudentDashboardHtml.useQuery()

	return (
		<Layout>
			{error ? (
				<p>Failed to load dashboard.</p>
			) : data === undefined ? (
				<PartialLoadingPage />
			) : (
				data && (
					<div className="rounded-lg bg-white p-6">
						<div className="editorjs" dangerouslySetInnerHTML={{ __html: data }} />
					</div>
				)
			)}
		</Layout>
	)
}

export default DashboardPage
